// Filename - pages/ContactUs.js

import React from "react";

const Contact = () => {
    return (
        <div className="welcome">
            <table align="center" width="90%">
                <tr align="center">
                    <td align="center">
                        <h3>
                            InfoTrawl Contacts
                        </h3>
                    </td>
                </tr>
            </table>
        </div>
    );
};

export default Contact;